import { type ReactNode } from "react";
import "./journal-section-page-header.scss";

type JournalSectionPageHeaderProps = {
  title: ReactNode;
  actions?: ReactNode;
  banner?: ReactNode;
};

export const JournalSectionPageHeader = ({
  title,
  actions,
  banner,
}: JournalSectionPageHeaderProps) => {
  return (
    <div className="journal-section-page-header">
      {banner ? (
        <div className="journal-section-page-header__banner">{banner}</div>
      ) : null}
      <div className="journal-section-page-header__row">
        <div className="journal-section-page-header__title">{title}</div>
        {actions ? (
          <div className="journal-section-page-header__actions">{actions}</div>
        ) : null}
      </div>
    </div>
  );
};
